<template>
  <!--================ banner =================-->
  <section v-if="bannerTopo != ''" class="breadcrumb_area">
    <div class="overlay bg-parallax">
      <img :src="$imagens + 'about_banner.jpg'" alt="">
    </div>
    <div class="container">
      <div class="page-cover text-center">
        <h2 class="page-cover-tittle">{{ bannerTopo[0].itiNome }}</h2>
        <ol class="breadcrumb">
          <li><router-link to="/">Home / </router-link></li>
          <li>{{ bannerTopo[0].itiNome }}</li>
        </ol>
      </div>
    </div>
  </section>

  <!--================ sobre a empresa  =================-->
  <section v-if="textoSobre != ''" class="about_history_area section_gap">
    <div class="container">
      <div class="row">
        <div class="col-md-6 d_flex align-items-center">
          <div class="about_content-sobre ">
            <h2 class="title title_color">{{ textoSobre[0].itiNome }}</h2>
            <p v-html="textoSobre[0].itiResumo1"></p>
            <p v-html="textoSobre[0].itiResumo2"></p>
          </div>
        </div>
        <div class="col-md-6 img-avance">
          <img :src="$imgURL + textoSobre[0].insInstitucionalImagens[0].itgUrlImagem" alt="">
        </div>
      </div>
    </div>
  </section>

  <!--================ missao visao  =================-->
  <section v-if="missaoVisao != ''" class="facilities_area section_gap">
    <div class="overlay bg-parallax">
      <img :src="$imagens + 'facilites_bg.jpg'" alt="">
    </div>
    <div class="container">
      <div class="row mb_30">
        <div v-for="quadros in missaoVisao" :key="quadros.itiId" class="col-lg-4 col-md-6">
          <div class="facilities_item">
            <h4 class="sec_h4">{{ quadros.itiNome }}</h4>
            <p v-html="quadros.itiResumo1"></p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--================ depoimentos =================-->
  <section v-if="depoimentos != ''" class="testimonial_area section_gap">
    <div class="container">
      <div class="section_title text-center">
        <h2 class="title_color">Depoimentos</h2>
      </div>
      <div class="testimonial_slider owl-carousel">
        <Swiper :navigation="false" :pagination="{ clickable: true }" :slides-per-view="2" :space-between="40"
          :breakpoints="{ 768: { slidesPerView: 2 }, 0: { slidesPerView: 1 } }">
          <SwiperSlide v-for="depo in depoimentos" :key="depo.itiId">
            <div class="media testimonial_item">
              <img :src="$imgURL + depo.insInstitucionalImagens[0].itgUrlImagem" class="rounded-circle">
              <div>
                <p v-html="depo.itiResumo1"></p>
                <a href="#">
                  <h4 class="sec_h4">{{ depo.itiNome }}</h4>
                </a>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </section>

  <!--=============== call to action ====================-->
  <PageCallAction></PageCallAction>

</template>

<script>
import axios from 'axios';
import { useHead } from '@vueuse/head';
import { Swiper, SwiperSlide } from 'swiper/vue';
import PageCallAction from '@/components/PageCallAction.vue';

export default {
  name: 'SobreView',
  components: {
    Swiper,
    SwiperSlide,
    PageCallAction,
  },

  data: () => ({
    bannerTopo: [],
    textoSobre: [],
    missaoVisao: [],
    depoimentos: [],
  }),

  methods: {
    carregaMetas(texto, titulo) {
      useHead({
        title: 'Garante Imob - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Garante Imob" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    this.carregaMetas("---");

    // bannerTopo
    axios.get('/Process/InsInstitucional/institucional/11/toposobre/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // texto sobre
    axios.get('/Process/InsInstitucional/institucional/12/textosobre/0/x')
      .then(response => {
        this.textoSobre = response.data;
        //console.log('textoSobre')
        //console.log(this.textoSobre)
      })
      .catch(error => {
        console.error(error);
      });

    // missaoVisao
    axios.get('/Process/InsInstitucional/institucional/14/itensdosobre/0/x')
      .then(response => {
        this.missaoVisao = response.data;
        //console.log('missaoVisao')
        //console.log(this.missaoVisao)
      })
      .catch(error => {
        console.error(error);
      });

    // depoimentos
    axios.get('/Process/InsInstitucional/institucional/42/depoimentos/0/x')
      .then(response => {
        this.depoimentos = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('depoimentos')
        //console.log(this.depoimentos)
      })
      .catch(error => {
        console.error(error);
      });

  }

}
</script>

<style scoped></style>